var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8223 14.527C10.6798 14.527 10.5373 14.4745 10.4248 14.362C10.2073 14.1445 10.2073 13.7845 10.4248 13.567L14.5798 9.41195L10.4248 5.25695C10.2073 5.03945 10.2073 4.67945 10.4248 4.46195C10.6423 4.24445 11.0023 4.24445 11.2198 4.46195L15.7723 9.01445C15.9898 9.23195 15.9898 9.59195 15.7723 9.80945L11.2198 14.362C11.1073 14.4745 10.9648 14.527 10.8223 14.527Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2475 9.97437H2.625C2.3175 9.97437 2.0625 9.71937 2.0625 9.41187C2.0625 9.10437 2.3175 8.84937 2.625 8.84937H15.2475C15.555 8.84937 15.81 9.10437 15.81 9.41187C15.81 9.71937 15.555 9.97437 15.2475 9.97437Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateArrow);
export default __webpack_public_path__ + "static/media/navigate-arrow.6ee9b955abe460bdb3c23f9aef036739.svg";
export { ForwardRef as ReactComponent };